import y18n from '../utils/i18n'
import { API_KEY } from '@/config/apiKey.js'

const translateTemplate = (key) => y18n.t(`config.feishu.${key}`)

// Feishu bot configuration
export const FEISHU_CONFIG = {
    // Robot webhook URL; prefer environment variable fallback
    WEBHOOK_URL: `https://open.feishu.cn/open-apis/bot/v2/hook/${API_KEY.FEISHU_WEBHOOK_KEY}`,
    
    // Message template helpers
    MESSAGE_TEMPLATE: {
        CONTACT_FORM: () => translateTemplate('contactTemplate'),
        SYSTEM_NOTIFICATION: () => translateTemplate('systemNotification'),
        ERROR_ALERT: () => translateTemplate('errorAlert')
    },
    
    // API config
    API_CONFIG: {
        timeout: 10000,
        headers: {
            'Content-Type': 'application/json'
        }
    }
}

// Message types
export const MESSAGE_TYPES = {
    TEXT: 'text',
    POST: 'post',
    IMAGE: 'image',
    SHARE_CHAT: 'share_chat',
    INTERACTIVE: 'interactive'
}

// Utility helpers
export const FeishuUtils = {
    // Format contact form payload
    formatContactMessage(formData, source = translateTemplate('source')) {
        const timestamp = new Date().toLocaleString('zh-CN')
        const templateFn = FEISHU_CONFIG.MESSAGE_TEMPLATE.CONTACT_FORM
        const template = typeof templateFn === 'function' ? templateFn() : templateFn
        return template
            .replace('{name}', formData.name)
            .replace('{email}', formData.email)
            .replace('{phone}', formData.phone)
            .replace('{subject}', formData.subject)
            .replace('{message}', formData.message)
            .replace('{source}', source)
            .replace('{timestamp}', timestamp)
    },
    
    // Build Feishu message object
    buildMessage(content, msgType = MESSAGE_TYPES.TEXT) {
        return {
            msg_type: msgType,
            content: {
                text: content
            }
        }
    }
}
